/**
 * Sets --cs-header-offset on collection-spotlights sections to match the distance from
 * the viewport top to the main template content (announcement + header + top bars).
 * Falls back to theme CSS defaults when the template root is missing.
 */
(function () {
  'use strict';

  if (window.__collectionSpotlightsHeaderOffsetInit) return;
  window.__collectionSpotlightsHeaderOffsetInit = true;

  var ATTR = '[data-measure-header-offset="true"]';

  function readTemplateTop() {
    var template = document.querySelector('[id^="template-"]');
    if (!template) return null;
    return Math.max(0, Math.round(template.getBoundingClientRect().top));
  }

  function apply() {
    var px = readTemplateTop();
    if (px === null) return;

    document.querySelectorAll(ATTR).forEach(function (el) {
      el.style.setProperty('--cs-header-offset', px + 'px');
    });
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  var run = debounce(function () {
    apply();
    requestAnimationFrame(function () {
      requestAnimationFrame(apply);
    });
  }, 50);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
  window.addEventListener('resize', run);
  window.addEventListener('orientationchange', run);

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest('.js-close-announcement')) {
        setTimeout(run, 400);
      }
    },
    true
  );
})();
